import { render, staticRenderFns } from "./QrcodeWeb.vue?vue&type=template&id=34b8997d&scoped=true&"
import script from "./QrcodeWeb.vue?vue&type=script&lang=js&"
export * from "./QrcodeWeb.vue?vue&type=script&lang=js&"
import style0 from "./QrcodeWeb.vue?vue&type=style&index=0&id=34b8997d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b8997d",
  null
  
)

export default component.exports